// extracted by mini-css-extract-plugin
export var aboveInput = "_j1-0";
export var actionButton = "_j1-5";
export var actionButtonContainer = "_j1-1";
export var actionIcon = "_j1-6";
export var aiInfoContainer = "_j1-2";
export var attachmentWrapper = "_j1-7";
export var bold = "_j1-3";
export var checkIcon = "_j1-8";
export var clickingRecipientBar = "_j1-11";
export var commentThreadSwitch = "_j1-a";
export var draftImage = "_j1-b";
export var draftImageContainer = "_j1-c";
export var draftImages = "_j1-e";
export var editButton = "_j1-g";
export var editor = "_j1-f";
export var editorContainer = "_j1-y";
export var editorErrorTooltipWrapper = "_j1-9";
export var headerDivider = "_j1-h";
export var icon = "_j1-i";
export var info = "_j1-j";
export var internal = "_j1-n";
export var internalDivider = "_j1-k";
export var internalMessage = "_j1-l";
export var messageInputCard = "_j1-m";
export var messageInputForm = "_j1-o";
export var messageInputFormInternal = "_j1-p";
export var options = "_j1-q";
export var publicMessageCustomer = "_j1-s";
export var publicMessageMerchant = "_j1-r";
export var removeImageButton = "_j1-d";
export var replyButtons = "_j1-t";
export var showSignatureButton = "_j1-u";
export var spinner = "_j1-v";
export var verticalButtonDivider = "_j1-4";
export var visibilitySelector = "_j1-w";
export var warning = "_j1-x";
export var wrappingText = "_j1-z";
export var writingInternalNoteTopBorder = "_j1-10";